import React from 'react';
import { SourceReference } from '../services/api';

interface Props {
  source: SourceReference;
  index: number;
}

export const SourceCard: React.FC<Props> = ({ source, index }) => (
  <a
    href={source.url}
    target="_blank"
    rel="noopener noreferrer"
    style={{
      display: 'block',
      padding: '8px 12px',
      margin: '4px 0',
      background: 'var(--bg-source)',
      borderRadius: 8,
      textDecoration: 'none',
      color: 'var(--text-source)',
      border: '1px solid var(--border-color)',
      fontSize: 13,
    }}
  >
    <strong>[{source.citationIndex || index + 1}]</strong> {source.title || source.url}
    <div style={{ color: 'var(--text-source-snippet)', fontSize: 12, marginTop: 4 }}>{source.snippet}</div>
  </a>
);
